<template>
  <nav>
    <router-link to="/"><span id="A">A</span><span id="W">W</span></router-link>
    <hr align="left">
    <router-link to="/about">about me</router-link>
    <hr align="left">
    <router-link to="/portfolio">portfolio</router-link>
    <hr align="left">
    <!-- <router-link to="/posts">posts</router-link>
    <hr align="left"> -->
    <router-link to="/sail">sail</router-link>
    <hr align="left">
  </nav>
</template>

<script>
export default {
  name: 'Menu'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../variables.scss';

nav {
  flex-shrink: 0;
  height: 100%;
  width: 200px;
  background-color: #61aac6;
  padding: 40px 0 0 75px;
  position: fixed;
}

nav:after {
  content: 'A';
  position: absolute;
  font-size: 3em;
  font-family: 'Roboto', sans-serif;
  bottom: 9px;
  font-weight: bold;
  right: -20px;
  color: #303036;
}

#A, #W {
  font-family: 'Roboto', sans-serif;
  font-size: 4em;
  font-weight: bold;
}
#A {
  letter-spacing: -0.29em;
}
#W {
  color: $gray;
}

a {
  color: inherit;
  text-decoration: none;
}
a:hover {
  color: $gray;
}

hr:nth-of-type(1) {
  width: 150px;
}
hr:nth-of-type(2) {
  width: 113px;
}
hr:nth-of-type(3) {
  width: 75px;
}
hr:nth-of-type(4) {
  width: 50px;
}
hr:nth-of-type(5) {
  width: 38px;
}
</style>
